export interface Topic {
  title: string;
  key: string;
  children: {
    title: string;
    value: string;
    orderNumberRequired?: boolean;
  }[];
}

const topics: Topic[] = [
  {
    title: 'App',
    key: 'app',
    children: [
      {
        title: 'I am having trouble with the App',
        value: 'app__i_am_having_trouble_with_the_app',
      },
    ],
  },
  {
    title: 'General',
    key: 'general',
    children: [
      {
        title: 'Other',
        value: 'other',
      },
    ],
  },
  {
    title: 'Marketing',
    key: 'competitions',
    children: [
      {
        title: 'Competitions',
        value: 'marketing_competitions',
      },
    ],
  },
  {
    title: 'Newsletter',
    key: 'newsletter',
    children: [
      {
        title: 'Change My Email Address',
        value: 'newsletter__change_my_email_address',
      },
      {
        title: "I don't receive your newsletter?",
        value: 'newsletter_not_receiving',
      },
      {
        title: 'Unsubscribe me please!',
        value: 'newsletter_unsubscribe',
      },
    ],
  },
  {
    title: 'Orders',
    key: 'orders',
    children: [
      {
        title: 'Change My Order',
        value: 'orders___change_my_order',
        orderNumberRequired: true,
      },
      {
        title: 'Change delivery address',
        value: 'change_address',
        orderNumberRequired: true,
      },
      {
        title: 'I received an incomplete shipment',
        value: 'incomplete_shipment',
        orderNumberRequired: true,
      },
      {
        title: 'I want to cancel my order',
        value: 'cancel_order',
        orderNumberRequired: true,
      },
      {
        title: 'When will my order arrive?',
        value: 'when_will_order_arrive',
        orderNumberRequired: true,
      },
      {
        title: 'Where is my parcel?',
        value: 'where_is_my_parcel',
        orderNumberRequired: true,
      },
    ],
  },
  {
    title: 'Payments',
    key: 'payments',
    children: [
      {
        title: 'Did you receive my payment?',
        value: 'payment_received',
      },
      {
        title: 'I have trouble paying',
        value: 'trouble_paying',
      },
    ],
  },
  {
    title: 'Product returns',
    key: 'returns',
    children: [
      {
        title: 'I have an issue with a product I received',
        value: 'returns_faulty_products',
        orderNumberRequired: true,
      },
      {
        title: 'I received a wrong product',
        value: 'returns_wrong_product',
        orderNumberRequired: true,
      },
      {
        title: 'I want to return a single item',
        value: 'return_single_item',
        orderNumberRequired: true,
      },
      {
        title: 'I want to return multiple items',
        value: 'return_multiple_items',
        orderNumberRequired: true,
      },
      {
        title: 'I would like to exchange',
        value: 'returns_exchange',
        orderNumberRequired: true,
      },
      {
        title: 'The product was damaged on arrival',
        value: 'product_was_damaged_on_arrival',
        orderNumberRequired: true,
      },
    ],
  },
  {
    title: 'Products',
    key: 'products',
    children: [
      {
        title: 'When are you running this product again?',
        value: 'previous_deal',
      },
      {
        title: 'About a product on sale today',
        value: 'product_specific',
      },
      {
        title: 'I have a question about vouchers',
        value: 'print_vouchers',
      },
      {
        title: 'Product suggestion',
        value: 'product_suggestion',
      },
      {
        title: 'Sell your product with us',
        value: 'sell_your_product',
      },
    ],
  },
  {
    title: 'Refunds',
    key: 'refunds',
    children: [
      {
        title: ' Where is my Refund?',
        value: ' refunds___where_is_my_refund_',
      },
    ],
  },
  {
    title: 'Website',
    key: 'website',
    children: [
      {
        title: 'I have trouble logging in',
        value: 'logging_in',
      },
    ],
  },
];

export default topics;
